<template>
  <div class="container product-box">
    <div class="product-list" v-if="datas.length>0">
      <ul>
        <li class="pro-item" v-for="(item,index) in datas" :key="index">
          <div class="pro-img">
            <img :src="item.imgUrl" />
            <div class="zhezhao" @click="$router.push({ path: '/proDetail', query: { coNu: item.co_Nu } })"></div>
          </div>
          <div class="pro-info">
            <p class="pr-na">{{ language === 'en' ? item.pr_En_Na : language === 'ru' ? item.basicThreeLanguage : item.pr_Na }}</p>
          </div>
          <div class="price-box">
            <p class="price">
              <span>{{ userInfo.symbol }}</span>
              {{ userInfo.status === 1 ? Number(item.price) : $t('viewPrice')}}
            </p>

            <img
              src="../../assets/tianshi/xuanzhong.jpg"
              alt
              style="margin-right: 10px;"
              v-if="markCart(item.co_Nu)"
              @click="handleToCart(item)"
            />
            <img src="../../assets/tianshi/weixuanzhong.jpg" alt style="margin-right: 10px;" v-else @click="handleToCart(item)" />
          </div>
          <div class="price-caiji" v-if="userInfo.id">
            <p class="price">{{ item.ou_Lo || 0 }}PCS</p>
            <p class="price">{{ item.bulk_Stere || 0 }}CBM</p>
          </div>
        </li>
      </ul>
    </div>
    <div v-else>
      <el-empty :description="$t('noData')"></el-empty>
    </div>
  </div>
</template>
<script>
import { deletCartsApi, addCartsApi } from '@/api/cart'
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  name: 'recommProduct',
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
    }),
    markCart() {
      return coNu => {
        // 购物车列表为空，直接返回标记
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    },
    // 用户信息
    ...mapState('user', ['userInfo']),
    // 语言
    ...mapState('operate', ['language'])
  },
  methods: {
    ...mapActions('operate', {
      addCart: 'add_cart',
      deleteCart: 'delete_cart',
      setEnquiry: 'set_enquiry'
    }),
    // 添加到购物车
    handleToCart(item) {
      // 必须登陆后才能添加购物车
      if (Object.keys(this.userInfo).length === 0) {
        this.$message({
          message: this.$t('noLogin'),
          type: 'warning'
        })
        return
      }
      if (this.markCart(item.co_Nu)) {
        deletCartsApi({
          userId: this.userInfo.id,
          coNus: [item.co_Nu]
        }).then(res => {
          if (res.success) {
            this.deleteCart(item.co_Nu)
          }
        })
      } else {
        addCartsApi({
          client_Nu: this.userInfo.client_Nu,
          userId: this.userInfo.id,
          co_Nu: item.co_Nu,
          number: 1
        }).then(res => {
          if (res.success) {
            this.addCart({
              client_Nu: this.userInfo.client_Nu,
              userId: this.userInfo.id,
              co_Nu: item.co_Nu,
              fa_No: item.fa_No,
              imgUrl: item.imgUrl,
              in_En: item.in_En,
              number: 1,
              ou_Lo: item.ou_Lo,
              pr_En_Na: item.pr_En_Na,
              pr_Na: item.pr_Na,
              price: item.price
            })
          }
        })
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.product-box {
  background: #ffffff;
  border-radius: 12px;
  .zhezhao {
    width: 220px;
    height: 240px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 1;
    border-radius: 6px;
    display: none;
  }
  & .tit-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & .tit {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      & h3 {
        font-size: 48px;
        font-weight: bold;
        color: #222;
        line-height: 60px;
      }

      & .sm-tit {
        font-size: 20px;
        line-height: 30px;
        padding: 20px 0;
        color: #222;
      }

      & .more {
        width: 120px;
        background-color: #2672be;
        color: #f5f5f5;
        border-radius: 6px;
        font-weight: bold;
      }
    }

    & .tit-img {
      width: 250px;
      height: 250px;

      & img {
        width: 100%;
      }
    }
  }

  & .product-list {
    width: 100%;
    margin-left: 25px;
    padding-top: 20px;
    & .pro-item {
      position: relative;
      width: 220px;
      background-color: #fff;
      border-radius: 12px;
      margin-right: 16px;
      margin-bottom: 30px;
      &:nth-child(5n) {
        margin-right: 16px;
      }

      & .ck-box {
        position: absolute;
        right: 5%;
        top: 1%;
      }

      & .pro-img {
        width: 220px;
        height: 220px;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        & img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 220px;
        }
      }

      .pro-img:hover {
        .zhezhao {
          display: block;
        }
      }

      & .pro-info {
        font-size: 14px;
        margin: 0 10px;
        & p {
          line-height: 30px;
          overflow: hidden;
          overflow: hidden;
          text-overflow: ellipsis;

          &.pr-no,
          &.pr-na {
            height: 30px;
          }
        }
      }
      & .price-caiji {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 10px;
        margin-top: 5px;
        & .price {
          font-size: 14px;
          font-weight: bold;
          color: #ff0000;

          & span {
            font-size: 14px;
          }
        }
      }
      & .price-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 10px;

        & .price {
          font-size: 14px;
          font-weight: bold;
          color: #ff0000;

          & span {
            font-size: 14px;
          }
        }

        img {
          cursor: pointer;
        }
      }
    }

    & ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      & li {
        background-color: #fff;
        width: 18.4%;
        border-radius: 5px;

        & .product-img {
          width: 90%;
          margin: 0 5% 5% 5%;
          overflow: hidden;
          height: 150px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          & img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 150px;
            transition-duration: 0.5s;
            &:hover {
              transition-duration: 0.5s;
              transform: scale(1.1);
            }
          }
        }

        & .product-txt {
          padding: 0 5%;

          & h3 {
            font-size: 16px;
            font-weight: normal;
            height: 30px;
            line-height: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          & .number {
            font-size: 14px;
            height: 30px;
            line-height: 30px;
          }

          & .price {
            font-size: 14px;
            color: #f24141;
            font-weight: bold;
            height: 25px;
            line-height: 25px;
          }
        }

        &:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>